import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
  useMemo,
} from 'react';
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { GridRowModes } from "@mui/x-data-grid";
import { isObjEmpty } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { failureToast } from "services/http";
import { saveOrDeleteMsg } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant";
import { newRow } from '../utils';
import { generateRandomId } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import { editCellContainerStyle } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { gridStyles, gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { ActionsCellComponent } from "views/pages/manage/masters/studentFinancials/paymentGatewaysConfiguration/common";
import ALoader from "views/pages/manage/common/a-loader";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import MultiSelectCellComponentWithSearch from "views/pages/manage/common/commonComponents/SearchFilterView/MultiSelectCellComponentWithSearch";
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import { regex } from "views/pages/manage/common/constant";
import { hardcodeDropdown } from 'modules/paymentManagement/common/services';


const ApprovalSettingTable = ({
  rows,
  loading,
  setLoading,
  currentPage,
  totalRecords,
  pageChangeHandler,
  allActiveRoles = [],
  form,
  setForm,
}, ref) => {

  const [rowModesModel, setRowModesModel] = useState({});
  const [rowData, setRowData] = useState(rows);
  const [rowForm, setRowForm] = useState({});

  const [isChequePayMode, setIsChequePayMode] = useState(false);

  const rowFormHandler = (value, key) =>
    setRowForm((prev) => ({
      ...prev,
      [key]: value
    }));

  useEffect(() => {
    setRowData(rows);
  }, [rows]);

  useEffect(() => {
    const isCheque = rowForm?.paymodeType?.value?.toLowerCase() === 'chkl';

    setIsChequePayMode(isCheque);
  }, [rowForm?.paymodeType]);

  const startEditing = (id, form) => {
    setRowModesModel((oldModel) => ({
      [id]: { mode: GridRowModes.Edit },
    }));
    setRowForm(form);
  };

  const stopEditing = () => {
    const currForm = { ...rowForm };
    setRowModesModel((oldModel) => ({
      [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
    }));
    setRowForm({});
  };

  const handleEditClick = (params) => {
    if (!isObjEmpty(rowForm)) {
      failureToast(saveOrDeleteMsg);
    } else {
      startEditing(params?.id, params?.row);
    }
  };

  const handleCancelClick = async (params) => {
    if (params?.row?.isNew) {
      setRowData(rows);
      setRowForm({});
    } else {
      stopEditing(params?.id);
    }
  };

  const handleSaveClick = () => {

    let tempRows = [...rows];

    if (rowForm?.isNew) {
      delete rowForm?.isNew;
      tempRows = [...tempRows, rowForm]
    } else {
      tempRows = [
        ...tempRows?.filter(row => row?.id !== rowForm?.id),
        rowForm
      ]
    }
    setForm(prev => ({
      ...prev,
      approvalSettingDTO: tempRows
    }))


    stopEditing();
  }

  const addNewRow = async () => {
    if (!isObjEmpty(rowForm)) {
      failureToast(saveOrDeleteMsg);
    } else {
      let randomId = generateRandomId();
      let emptyRow = {
        ...newRow,
        isNew: true,
        id: randomId,
      };
      startEditing(randomId, emptyRow);
      setRowData((prev) => [emptyRow, ...prev]);
    }
  };

  const isTableInEditMode = Object.keys(rowForm)?.length !== 0;

  const getPaymodeTypeDropdown = (row) => {
    const filteredTypes = hardcodeDropdown?.paymodeTypes?.filter(
      type => !rowData?.some(existing => existing?.paymodeType === type)
    ) || [];

    if (!row.isNew) {
      const currentType = rowData?.find(el => el?.id === row?.id)?.paymodeType;
      if (currentType) filteredTypes.push(currentType);
    }

    return filteredTypes;
  }

  useImperativeHandle(ref, () => ({
    addNewRow: addNewRow,
    startEditing: startEditing,
    stopEditing: stopEditing,
    isTableInEditMode: isTableInEditMode
  }));

  const isLevelsValid = useMemo(() => {
  const hasL1 = rowForm?.l1Roles?.length > 0;
  const hasL2 = rowForm?.l2Roles?.length > 0;
  const hasL3 = rowForm?.l3Roles?.length > 0;

  const l1Valid = !hasL1 || (hasL1 && rowForm?.l1Days);
  const l2Valid = !hasL2 || (hasL2 && rowForm?.l2Days);
  const l3Valid = !hasL3 || (hasL3 && rowForm?.l3Days);

  return l1Valid && l2Valid && l3Valid;
}, [rowForm]);


  const columns = useMemo(() => [
    new AGridColDef("paymodeType", "Paymode type*", false)
      .setMinWidth(120)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value?.label)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.paymodeType}
            handleChange={(value) => {
              rowFormHandler(value, "paymodeType");
            }}
            items={getPaymodeTypeDropdown(params?.row)}
            isMulti={false}
            placeholder={"Select"}
            autoFocus={params?.hasFocus}
          />
        </div>
      )),
    new AGridColDef("l1Roles", "L1 Roles*", false)
      .setMinWidth(150)
      .setFlex(1)
      .editable(true)
      .renderCellComponent((params) =>
        <MultiSelectCellComponentWithSearch
          data={params?.value}
          title={'L1 Roles'}
        />
      )
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.l1Roles}
            handleChange={(value) => {
              rowFormHandler(value, "l1Roles");
            }}
            items={allActiveRoles}
            isMulti={true}
            placeholder={"Select"}
            autoFocus={params?.hasFocus}
            isShowCount
          />
        </div>
      )),
    new AGridColDef("l1Days", "Set L1 (No. of days)*", false)
      .setMinWidth(100)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.l1Days}
            handler={(val) => {
              if (val === "" || val === null) {
                rowFormHandler("", "l1Days");
              } else {
                rowFormHandler(val, "l1Days");
              }
            }}
            placeholder={""}
            regex={regex?.numericDecimal}
            disabled={!isChequePayMode || rowForm?.l1Roles?.length === 0} 
          />
        </div>
      )),
    new AGridColDef("l2Roles", "L2 Roles", false)
      .setMinWidth(150)
      .setFlex(1)
      .editable(true)
      .renderCellComponent((params) =>
        <MultiSelectCellComponentWithSearch
          data={params?.value}
          title={'L2 Roles'}
        />
      )
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.l2Roles}
            handleChange={(value) => {
              rowFormHandler(value, "l2Roles");
            }}
            items={allActiveRoles}
            isMulti={true}
            placeholder={"Select"}
            autoFocus={params?.hasFocus}
            isShowCount
            isDisabled={!rowForm?.l1Roles || rowForm?.l1Roles?.length === 0}
          />
        </div>
      )),
    new AGridColDef("l2Days", "Set L2 (No. of days)", false)
      .setMinWidth(100)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.l2Days}
            handler={(val) => {
              if (val === "" || val === null) {
                rowFormHandler("", "l2Days");
              } else {
                rowFormHandler(val, "l2Days");
              }
            }}
            placeholder={""}
            regex={regex?.numericDecimal}
            disabled={!isChequePayMode || rowForm?.l2Roles?.length === 0}
          />
        </div>
      )),
    new AGridColDef("l3Roles", "L3 Roles", false)
      .setMinWidth(150)
      .setFlex(1)
      .editable(true)
      .renderCellComponent((params) =>
        <MultiSelectCellComponentWithSearch
          data={params?.value}
          title={'L3 Roles'}
        />
      )
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.l3Roles}
            // currentValue={rowForm.businessArea ?? rowForm?.businessArea ?? {label : '', value : ''}}
            handleChange={(value) => {
              rowFormHandler(value, "l3Roles");
            }}
            items={allActiveRoles}
            isMulti={true}
            placeholder={"Select"}
            autoFocus={params?.hasFocus}
            isShowCount
            isDisabled={!rowForm?.l2Roles || rowForm?.l2Roles?.length === 0}
          />
        </div>
      )),
    new AGridColDef("l3Days", "Set L3 (No. of days)", false)
      .setMinWidth(100)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AInput
            value={rowForm?.l3Days}
            handler={(val) => {
              if (val === "" || val === null) {
                rowFormHandler("", "l3Days");
              } else {
                rowFormHandler(val, "l3Days");
              }
            }}
            placeholder={""}
            regex={regex?.numericDecimal}
            disabled={!isChequePayMode || rowForm?.l3Roles?.length === 0}
          />
        </div>
      )),
    new AGridColDef("actions", "Action", false)
      .setMinWidth(160)
      .setFlex(2)
      .editable(true)
      // .pinColumnLast(true)
      .renderCellComponent(
        (params) =>

          <ActionsCellComponent
            mode={"view"}
            handleEditClick={handleEditClick}
            params={params}
          />
      )
      .renderEditCellComponent((params) => (
        <ActionsCellComponent
          mode={"edit"}
          isSaveDisabled={
            !rowForm?.paymodeType ||
            !rowForm?.l1Roles?.length ||
            isChequePayMode&&!isLevelsValid
          }
          handleSaveClick={handleSaveClick}
          params={params}
          cancelIcon={
            <AButton
              variant="danger_filled"
              size="xs"
              onClick={() => handleCancelClick(params)}
            >
              Discard
            </AButton>
          }
        />
      )),
  ], [
    rowForm,
    isChequePayMode,
    allActiveRoles,
    rowData,
    handleEditClick,
    handleSaveClick,
    handleCancelClick,
    getPaymodeTypeDropdown
  ]);


  return (
    <>
      {loading && <ALoader position="fixed" />}
      <ADataGrid
        removeWrapperContainer
        rowModesModel={rowModesModel}
        rows={rowData || []}
        columns={columns}
        rowId={(row) => row.id}
        rowHeight={50}
        loading={false}
        rowCount={rows?.length || 0}
        hidePagination
        nextButtonHandler={pageChangeHandler}
        currentPage={currentPage}
        components={{
          ...gridComponents,
          NoRowsOverlay: () => (
            <NoRowOverlay message={loading ? "Loading..." : null} />
          ),
        }}
        sx={gridStyles}
        autoHeight
      />
    </>
  )
}

export default forwardRef(ApprovalSettingTable);